class ServerURL {
  static getAPIUrl() {
    var apiURL = process.env.REACT_APP_HOST_URL;
    return apiURL;
  }
  static getImageUploadUrl() {
    return process.env.REACT_APP_IMAGE_UPLOAD_URL;
  }
}
export default ServerURL;
